/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNumber } from '../../factoriesAny.js';
export var numberDependencies = {
  typedDependencies,
  createNumber
};